export enum DashboardReport {
  OrdersWrittenthismonth = "Orders Written this month",
  OrdersBilledInvoiced = "Orders Billed / Invoiced",
  OrdersbyInHandsdate = "Orders by In Hands date​",
  CustomerAging = "Charge back Aging Report",
  ReadyToBill = "Ready To Bill​​",
  CustomerYearOverYear = "Customer Year Over Year",
  TopClients = "Top Clients",
  MyOpenPOs = "My Open PO’s​​​",
  OrderDetail = "Order Detail​​​​​",
  CustomerwithDepositsandPrebills = "Customer with Deposits and Pre-bills​​",
  TasksbyDueDate = "Tasks by Due Date​​​​",
  InvoicesPostedthismonth = "Invoices Posted this month",
  ArAging = "AR Aging",
  ReadyToBillReport = "Ready To Bill Report",
  YearOverYearDashboardReport = "Year over Year Dashboard",
}
